/**
 * The company's social profiles, in display order. Used by every footer that
 * shows social icons and by the Organization JSON-LD `sameAs` in the root
 * layout, so a URL changes in one place.
 *
 * Glyphs come from SVG Repo. Each `path` is drawn with `fill-rule="evenodd"`,
 * so inner shapes (the "in", the "f", the gaps in Instagram's outline) are
 * cut out and the whole icon takes the text color. Instagram's three source
 * paths are merged into one for that reason.
 */
export interface SocialLink {
  name: "LinkedIn" | "Instagram" | "Facebook";
  href: string;
  /** Cropped to the glyph's bounds, so every icon renders at the same size and its edge is the glyph's edge. */
  viewBox: string;
  path: string;
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/skillscan-uk",
    viewBox: "0 0 504.4 504.4",
    path: "M377.6,0.2H126.4C56.8,0.2,0,57,0,126.6v251.6c0,69.2,56.8,126,126.4,126H378c69.6,0,126.4-56.8,126.4-126.4V126.6 C504,57,447.2,0.2,377.6,0.2z M168,408.2H96v-208h72V408.2z M131.6,168.2c-20.4,0-36.8-16.4-36.8-36.8c0-20.4,16.4-36.8,36.8-36.8 c20.4,0,36.8,16.4,36.8,36.8C168,151.8,151.6,168.2,131.6,168.2z M408.4,408.2H408h-60V307.4c0-24.4-3.2-55.6-36.4-55.6 c-34,0-39.6,26.4-39.6,54v102.4h-60v-208h56v28h1.6c8.8-16,29.2-28.4,61.2-28.4c66,0,77.6,38,77.6,94.4V408.2z",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/skillscan.uk/",
    viewBox: "0 0 169.063 169.063",
    path: "M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752 c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407 c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752 c17.455,0,31.656,14.201,31.656,31.655V122.407z M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561 C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561 c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78 c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78 C135.661,29.421,132.821,28.251,129.921,28.251z",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61589479720244",
    viewBox: "2 2 20 20",
    path: "M22 12C22 6.47714 17.5229 1.99999 12 1.99999C6.47715 1.99999 2 6.47714 2 12C2 16.9913 5.65686 21.1283 10.4375 21.8785V14.8906H7.89844V12H10.4375V9.79687C10.4375 7.29062 11.9304 5.90624 14.2146 5.90624C15.3087 5.90624 16.4531 6.10155 16.4531 6.10155V8.56249H15.1921C13.9499 8.56249 13.5625 9.33333 13.5625 10.1242V12H16.3359L15.8926 14.8906H13.5625V21.8785C18.3431 21.1283 22 16.9913 22 12Z",
  },
];
